
import Vue from "vue";
import { AUTH } from "@/store/auth";
import { mapGetters, mapState, mapActions } from "vuex";
import { IRootState } from "@/store/types";
import { ASSUME_ROLE_ENABLED } from "@/helpers/config";
import { isInRole } from "@/helpers/auth";
import { SUPPORT } from "@/constants/roles";

export default Vue.extend({
  methods: {
    ...mapActions({
      assumeRole: AUTH.NS(AUTH.ACTIONS.ASSUME_ROLE),
      resetRoles: AUTH.NS(AUTH.ACTIONS.RESET_ROLES)
    })
  },
  computed: {
    isEnabled() {
      return ASSUME_ROLE_ENABLED && (isInRole(SUPPORT) || this.isAssumingRole);
    },
    ...mapGetters({
      assumedRole: AUTH.NS(AUTH.GETTERS.GET_ASSUMED_ROLE)
    }),
    ...mapState({
      issuedRoles: (state: IRootState) => state.auth.issuedRoles,
      isAssumingRole: (state: IRootState) => state.auth.isAssumingRole
    })
  }
});
